import { useAuth } from '../../contexts/AuthContext'
import { usePermissions } from '../../hooks/usePermissions'
import { useNavigate } from 'react-router-dom'
import ThemeToggle from '../ui/ThemeToggle'
import NotificationsDropdown from '../notifications/NotificationsDropdown'
import { LogOut, User as UserIcon } from 'lucide-react'
import { Menu } from '@headlessui/react'
import Avatar from '../ui/Avatar'

export default function Header({ onMenuToggle, sidebarCollapsed }) {
  const { user, logout } = useAuth()
  const { role } = usePermissions()
  const navigate = useNavigate()

  return (
    <header className="sticky top-0 z-30 pt-3 sm:pt-4 px-2 sm:px-3 lg:px-0">
      <div className="flex items-center justify-between px-3 sm:px-4 lg:px-6 xl:px-8 py-2.5 sm:py-3 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md shadow-soft border border-pastel-pink/80 dark:border-slate-600 rounded-3xl">
        <div className="flex items-center space-x-2 sm:space-x-3 min-w-0 flex-1">
          <button
            type="button"
            className="lg:hidden p-2 rounded-xl text-pastel-ink/80 dark:text-slate-100 hover:bg-pastel-cream dark:hover:bg-slate-700 transition-all duration-300 flex-shrink-0 hover:scale-110 active:scale-95"
            onClick={onMenuToggle}
            aria-label="Toggle menu"
          >
            <svg className="h-6 w-6 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          {!sidebarCollapsed && (
            <h1 className="text-lg sm:text-xl font-bold text-pastel-teal truncate animate-fade-in">
              Artemis
            </h1>
          )}
        </div>

        <div className="flex items-center space-x-1 sm:space-x-2 lg:space-x-3 flex-shrink-0">
          {/* Theme Toggle */}
          <ThemeToggle />

          {/* Notificaciones */}
          <NotificationsDropdown />

          {/* User Menu */}
          <div className="flex items-center space-x-1 sm:space-x-2 lg:space-x-3 pl-2 sm:pl-3 border-l border-pastel-pink dark:border-slate-600">
            <div className="hidden md:block text-right">
              <p className="text-sm font-medium text-pastel-ink dark:text-white truncate max-w-[120px]">
                {user?.nombre} {user?.apellido || ''}
              </p>
              <p className="text-xs text-slate-500 dark:text-slate-300 capitalize truncate">
                {role?.replace('_', ' ').toLowerCase()}
              </p>
            </div>
            
            {/* User Dropdown Menu */}
            <Menu as="div" className="relative">
              <Menu.Button className="flex-shrink-0 shadow-soft hover:shadow-md hover:scale-110 transition-all duration-300 cursor-pointer focus:outline-none focus:ring-2 focus:ring-pastel-teal focus:ring-offset-2 rounded-full">
                <Avatar user={user} size="md" />
              </Menu.Button>
              
              <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right bg-white dark:bg-slate-800 divide-y divide-pastel-pink dark:divide-slate-700 rounded-2xl shadow-medium ring-1 ring-pastel-pink dark:ring-slate-700 focus:outline-none z-50">
                <div className="px-1 py-1">
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        onClick={() => navigate('/perfil')}
                        className={`${
                          active ? 'bg-pastel-teal text-white' : 'text-pastel-ink dark:text-slate-100'
                        } group flex rounded-md items-center w-full px-2 py-2 text-sm transition-colors`}
                      >
                        <UserIcon className="w-4 h-4 mr-3" />
                        Mi Perfil
                      </button>
                    )}
                  </Menu.Item>
                </div>
                <div className="px-1 py-1">
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        onClick={logout}
                        className={`${
                          active ? 'bg-rose-500 text-white' : 'text-rose-600 dark:text-rose-400'
                        } group flex rounded-md items-center w-full px-2 py-2 text-sm transition-colors`}
                      >
                        <LogOut className="w-4 h-4 mr-3" />
                        Cerrar Sesión
                      </button>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Menu>
          </div>
        </div>
      </div>
    </header>
  )
}
